/* XNote Voice page (docs/build/voice-r2/PLAN.md §8.4, §3.1, §3.2). Deferred, loaded by sections/xp-voice-hero. Events
   (CustomEvent 'xp:voice' on document + Shopify.analytics.publish('xp_voice_<name>') when present; no PII), the sign-up
   source tag, the ledger disclosure on phones, the app card reveal and the hero loop's 3-cycle stop. Sticky, focus and
   scroll logic stay in xp-base.js; without this file the page renders its end states.
   voice-launch (2026-10-05, LAUNCH-PLAN §4.2): a form inside [data-voice-src-lock] (the closing offer band) keeps the
   source tag it was rendered with, and its sign-ups publish notify_submit with that source. */
(() => {
  const d = document, h = d.documentElement, q = (s, e = d) => e.querySelector(s), qa = (s, e = d) => [...e.querySelectorAll(s)];
  h.classList.add('xp-vjs');
  const buy = q('#voice-buy');
  const state = () => (buy ? buy.dataset.voiceKind : '');
  const seg = /[?&]utm_source=xnote-customers\b/.test(location.search) ? 'existing' : 'new';
  let src = seg === 'existing' ? 'email' : 'hero';
  const ev = (name, x = {}) => {
    const detail = Object.assign({ name, state: state() }, x);
    d.dispatchEvent(new CustomEvent('xp:voice', { detail }));
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish('xp_voice_' + name, detail); } catch (e) {}
  };
  const setSrc = (s) => {
    src = s;
    qa('[data-xp-src-base]').forEach((i) => {
      if (i.closest('[data-voice-src-lock]')) return;
      i.value = i.dataset.xpSrcBase + ',voice-src-' + s;
      const n = q('[data-xp-news]', i.form);
      if (n) n.value = i.value + ',newsletter';
    });
  };
  setSrc(src);
  d.addEventListener('click', (e) => {
    const t = e.target.closest('[data-voice-src],[data-voice-event]');
    if (!t) return;
    if (t.dataset.voiceSrc) {
      setSrc(t.dataset.voiceSrc);
      if (t.dataset.voiceSrc !== 'close') ev(t.dataset.voiceSrc + '_tap');
    }
    if (t.dataset.voiceEvent) ev(t.dataset.voiceEvent, t.dataset.voiceLink ? { link: t.dataset.voiceLink } : {});
    const a = t.closest('a[href^="#voice-tba-"]');
    if (a) openLedger();
  });
  d.addEventListener('submit', (e) => {
    const lock = e.target.closest('[data-voice-src-lock]');
    if (lock) ev('notify_submit', { source: lock.dataset.voiceSrcLock, segment: seg });
    else if (buy && buy.contains(e.target)) ev('notify_submit', { source: src, segment: seg });
  });

  /* Ledger: one counted disclosure on phones (server-rendered open for no-JS and desktop). */
  const led = q('[data-voice-ledger-open]'), wide = matchMedia('(min-width: 1024px)');
  const fit = () => { if (!led) return; const o = wide.matches || /^#voice-tba-/.test(location.hash); if (o && !led.open) led.dataset.auto = '1'; led.open = o; };
  const openLedger = () => { if (led && !led.open) { led.dataset.auto = '1'; led.open = true; } };
  fit();
  wide.addEventListener('change', fit);
  addEventListener('hashchange', () => { if (/^#voice-tba-/.test(location.hash)) openLedger(); });
  d.addEventListener('toggle', (e) => {
    const t = e.target;
    if (!t.open) return;
    if (t === led) { if (!wide.matches && !t.dataset.auto) ev('ledger_expand', { count: qa('li', t).length }); delete t.dataset.auto; }
    else if (t.matches('[data-xp-dont]')) ev('dont_open');
    else if (t.matches('[data-voice-why-open]')) ev('why_compare_open');
    else if (t.closest('.xp-vfaq')) ev('faq_open', { id: t.id });
  }, true);

  /* The app card reveal: once, when ≥ 50 % in view (CSS shows the end state without motion, Save-Data or JS). */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((x) => { if (x.isIntersecting) { x.target.classList.add('is-run'); io.unobserve(x.target); } }), { threshold: 0.5 });
    qa('[data-voice-reveal]').forEach((c) => io.observe(c));
  }

  /* Swipe rows (the app features on phones): a row that scrolls sideways gets a tab stop (as xp-cap.js on Home). */
  const rows = qa('[data-voice-row]');
  const sync = () => rows.forEach((r) => { if (r.scrollWidth > r.clientWidth + 2) r.setAttribute('tabindex', '0'); else r.removeAttribute('tabindex'); });
  if (rows.length) { sync(); addEventListener('resize', () => requestAnimationFrame(sync)); }

  /* Hero loop: stops on its first frame after 3 cycles (WCAG 2.2.2; a tap on the tile plays it again). */
  qa('[data-voice-loop] video').forEach((v) => {
    let last = 0, cycles = 0, auto = true;
    const btn = q('[data-xp-pause]', v.parentElement);
    v.addEventListener('timeupdate', () => {
      if (v.currentTime + 0.5 < last && auto && ++cycles >= 3) {
        auto = false; v._xpUserPaused = true; v.pause(); v.currentTime = 0;
        if (btn) btn.setAttribute('aria-pressed', 'true');
      }
      last = v.currentTime;
    });
    [v, btn].forEach((el) => el && el.addEventListener('click', () => setTimeout(() => { auto = false; if (v._xpUserPaused) ev('loop_pause', { cycle: cycles + 1 }); })));
  });
})();
